import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { videoType } from '../../../utils/shared';
import shared from '../../../utils/shared';
import _ from 'lodash';
import { connect } from 'react-redux';

class VideoMiami extends Component {

  constructor(props) {
    super(props);

    this._videoPaused = false;
    this._videoRef = null;
    this._videoLengthTimeout = null;
    this._videoTimeout = null;
    this._metadataLoaded = false;
    this._dataLoaded = false;
    this._currentVideoLength = 0;

    this.state = {
      contentIndex: this.props.contentIndex,
      content: this.props.donorsData[this.props.contentIndex],
      videoOffsetY: 0,
      videoOffsetX: 0,
      showVideo: false
    };
  }

  componentDidMount() {
    this.initPlayer();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.contentIndex !== prevProps.contentIndex) {
      this.unbindEvents();
      this.setState({
        contentIndex: this.props.contentIndex,
        content: this.props.donorsData[this.props.contentIndex],
        videoOffsetY: 0,
        videoOffsetX: 0,
        showVideo: false
      });
      this.initPlayer();
    }
  }

  unbindEvents = () => {
    this._videoRef.removeEventListener('loadedmetadata', this.loadedMetadata);
    this._videoRef.removeEventListener('loadeddata', this.loadedData);
    this._videoRef.removeEventListener('ended', this.props.clickAction);
  }

  initPlayer = () => {
    let player = this._videoRef;
    player.addEventListener('loadedmetadata', this.loadedMetadata);
    player.addEventListener('loadeddata', this.loadedData);
    player.addEventListener('ended', this.props.clickAction);
  }

  getBackgroundImage = () => {
    const defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' }

    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    const folderModule = this.props.content.folder_modules.find(fm => fm.id === this.state.content.folder_module_id);
    const parentFolder = this.props.content.story_categories.find(folder => folder.id === folderModule.folder);
    const backgroundObj = _.get(parentFolder, 'contents.images[2]', null);
    return shared.dp(this.props.screen, backgroundObj, null);
  }

  loadedMetadata = () => {
    this._metadataLoaded = true;
    this.checkIfAllDataLoaded();
  }

  loadedData = () => {
    this._dataLoaded = true;
    this.checkIfAllDataLoaded();
  }

  checkIfAllDataLoaded = () => {
    if (this._metadataLoaded && this._dataLoaded) {
      this.setState({
        showVideo: true
      });
      this.positionVideo();
    }
  }

  positionVideo = () => {
    if (!this._videoRef) {
      setTimeout(() => {
        this.positionVideo();    
      }, 100);
      return;
    }

    let videoHeight = this._videoRef.getBoundingClientRect().height;
    let videoWidth = this._videoRef.getBoundingClientRect().width;

    let videoOffsetY = (this.props.screen.screenHeight / 2) - (videoHeight / 2);
    let videoOffsetX = (this.props.screen.screenWidth / 2) - (videoWidth / 2);

    if (this.props.screensNumber === 2){
      videoOffsetX = ((this.props.screen.screenWidth / 2) - videoWidth) / 2;
    }

    let videoControlsOffset = videoOffsetY + (videoHeight / 2);

    this.setState({
      videoOffsetY: videoOffsetY,
      videoOffsetX: videoOffsetX,
      videoControlsOffset: videoControlsOffset,
      videoFile: this.props.content.file_path
    });
  } 

  handleNext() {
    // let nextIndex = shared.loopIndex(this.state.contentIndex, 0, this.props.donorsData.length - 1, 'forward');
    this.props.handleNext();
    // this.setState({
    //   contentIndex: nextIndex,
    //   content: this.props.donorsData[nextIndex]
    // });
  }

  handlePrevious() {
    // let previousIndex = shared.loopIndex(this.state.contentIndex, 0, this.props.donorsData.length - 1, 'backward');
    this.props.handlePrevious();
    // this.setState({
    //   contentIndex: previousIndex,
    //   content: this.props.donorsData[previousIndex]
    // });
  }

  render() {
    let _videoStyle = {
      preload: 'auto',
      position: 'absolute',
      maxWidth: '80%',
      maxHeight: '85%',
      muted: "",
    }

    let background = this.getBackgroundImage();
    let cType = videoType(this.state.content.contents.images[1].file_name);
    let videoSrc = shared.dp(this.props.screen, this.state.content.contents.images[1]);
    if (this.props.screensNumber === 2){
      _videoStyle.maxWidth = '40%'
      background = null;
    }    
    return (
      <div>
        <CSSTransitionGroup
          component='div'
          className="slowfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.contentIndex} className="miami-video" style={{ display: this.state.showVideo ? 'block' : 'none' }}>
            <video key={this.state.contentIndex} className="videopills" style={{ ..._videoStyle, top: this.state.videoOffsetY, left: this.state.videoOffsetX }} ref={el => this._videoRef = el} autoPlay controls controlsList="nodownload">
              <source key={this.state.contentIndex} src={videoSrc} type={cType} />
              Your browser does not support the video tag.
            </video>
          </div>
        </CSSTransitionGroup >
        <div style={{ position: 'relative', top: this.state.videoControlsOffset, display: this.state.showVideo ? 'block' : 'none' }} ref="videoControls">
          <div onMouseDown={() => this.handlePrevious()} style={{ position:"absolute",  left: '0.3vh', width: "5vh", height: "15vh", top: "-5.2083vh" }}></div>
          <div onMouseDown={() => this.handleNext()} style={{ position:"absolute",  left: '51vh', width: "5vh", height: "15vh", top: "-5.2083vh" }}></div>
          <span onMouseDown={() => this.handlePrevious()} style={{ position: 'absolute', left: '0.7812vh', fontSize: "4vh", fontWeight: 'bold' }}>{'<'}</span>
          <span onMouseDown={() => this.handleNext()} style={{ position: 'absolute', left: '52.3437vh', fontSize:"4vh" , fontWeight: 'bold' }}>{'>'}</span>
        </div>
        <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: "cover", backgroundImage: `url(${background})` }} onMouseDown={this.props.clickAction}>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    content: state.content,
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(VideoMiami);


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/VideoMiami.js